import { useEffect, useState, type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { sessionApi, setTokenDeletedHandler } from '@/api/sessionApi'
import { getAccessToken, clearSessionStorage } from './session'

export function AuthGate({ children }: { children: ReactNode }) {
  const location = useLocation()
  const [ok, setOk] = useState(() => Boolean(getAccessToken()))

  useEffect(() => {
    setTokenDeletedHandler(() => {
      clearSessionStorage()
      setOk(false)
    })
  }, [])

  useEffect(() => {
    let cancelled = false
    const token = getAccessToken()
    if (!token) {
      setOk(false)
      return
    }
    setOk(true)
    sessionApi
      .authorizedUser()
      .then((res) => {
        if (cancelled) return
        if (res.data === 'Token deleted successfully') {
          clearSessionStorage()
          setOk(false)
        } else {
          setOk(true)
        }
      })
      .catch(() => {
        if (cancelled) return
        clearSessionStorage()
        setOk(false)
      })
    return () => {
      cancelled = true
    }
  }, [location.pathname])

  if (!ok) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
